<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div>
    <div
      class="giga-simulation_card"
      :id="`sim-${simulation.name}`"
      :class="{
        'active-alert':
          simulation.status === 'CARRIED_OUT' &&
          canValidateSimulation &&
          !simulation.isDraft
      }"
    >
      <!-- NOTIFICATION -->
      <div
        v-if="
          simulation.status === 'CARRIED_OUT' &&
            canValidateSimulation &&
            !simulation.isDraft
        "
        class="giga-simulation_alert"
      >
        <div class="giga-simulation_alert_8">
          <label class="giga-simulation_alert_title">{{
            $t("send_to_leyton_or_delete_your_project")
          }}</label>
        </div>
        <div class="giga-simulation_alert_4">
          <ul class="giga-simulation_alert_actions">
            <li class="alert-action_item">
              <div class="giga-button">
                <button
                  @click.stop.prevent="
                    openConfirmModal('confirm-validation', simulation.id)
                  "
                  class="giga-green_button no-icon"
                >
                  {{ $t("send") }}
                </button>
              </div>
            </li>
            <li class="alert-action_item">
              <div class="giga-button">
                <button
                  @click.stop.prevent="
                    openConfirmModal('confirm-lose', simulation.id)
                  "
                  class="giga-white_outlined_button no-icon"
                >
                  {{ $t("delete") }}
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div
        class="giga-flexible_card"
        :class="{ 'is-draft': simulation.isDraft }"
        :style="{
          backgroundColor:
            simulation.status === 'CANCEL'
              ? '#fef7f7'
              : simulation.isDraft
              ? '#f6f9fc'
              : '',
          border: simulation.status === 'CANCEL' ? 'solid 1.6px #ffdfd6' : ''
        }"
      >
        <div class="giga-flexible_card_header">
          <div class="HeaderClass">
            <h3 class="giga-flexible_card_title">{{ simulation.name }}
              <span class="tooltip-container"  v-if="(simulation.cofracState === 'BOTH' || simulation.cofracState === 'ONLY_COFRAC')
                                                      &&!simulation.isDraft && simulation.status !== 'CANCEL' &&
                                                      (simulation.status === 'NEW' || simulation.status === 'CARRIED_OUT' || simulation.status === 'TO_BE_TRANSFORMED')">
                  <svg class="warning-icon" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
                    <path class="triangle"
                          d="M7.5 1.2
                         C7 1.2 6.7 1.5 6.5 1.8
                         L0.8 11.2
                         A1.5 1.5 0 0 0 2.2 13
                         H12.8
                         A1.5 1.5 0 0 0 14.2 11.2
                         L8.5 1.8
                         C8.3 1.5 8 1.2 7.5 1.2Z"
                    />
                    <path class="exclamation-mark"
                          d="M7.5 3.5C7.75 3.5 8 3.75 8 4L7.8 8C7.8 8.25 7.6 8.5 7.5 8.5C7.4 8.5 7.2 8.25 7.2 8L7 4C7 3.75 7.25 3.5 7.5 3.5Z"
                    />
                    <circle class="exclamation-mark" cx="7.5" cy="10.5" r="0.8" />
                  </svg>
                  <span class="tooltip-text">{{ $t("quality_control_required") }}</span>
                </span>
              <span class="tooltip-container" v-if="simulation.isRgeInstaller
                                             &&!simulation.isDraft &&simulation.status !== 'CANCEL' &&
                                             (simulation.status === 'NEW' || simulation.status === 'CARRIED_OUT'|| simulation.status === 'TO_BE_TRANSFORMED')">
                 <img
                     src="@/assets/images/rge.png"
                     alt="RGE"
                     class="rge-icon"
                 />
                  <span class="tooltip-text">{{ $t("rge_installer_required") }}</span>
                </span>
            </h3>
            <span
              v-if="simulation.isDraft && simulation.status !== 'CANCEL'"
              class="draft-badge"
              >Brouillon</span
            >
            <span v-if="simulation.status === 'CANCEL'" class="perdu-badge"
              >Perdu</span
            >
          </div>
          <span class="giga-flexible_card_badge">{{
            simulation.numberOfNotifications
          }}</span>
          <ul class="giga-simulation_process_statuses">
            <!-- inProgress -->
            <li
              class="giga-simulation_status"
              :class="[
                simulation.status == 'NEW' ? 'done' : '',
                simulation.status == 'CARRIED_OUT' ? 'done' : '',
                simulation.status == 'TO_BE_TRANSFORMED' ? 'done' : ''
              ]"
            >
              <span
                :style="{
                  backgroundColor: simulation.isDraft
                    ? '#f6f9fc'
                    : simulation.status === 'CANCEL'
                    ? '#fef7f7'
                    : ''
                }"
                >Estimation Volume</span
              >

              <!-- NEW -->
            </li>

            <li
              class="giga-simulation_status"
              :class="[
                simulation.status == 'CARRIED_OUT' ? 'done' : '',
                simulation.status == 'TO_BE_TRANSFORMED' ? 'done' : ''
              ]"
            >
              <span
                :style="{
                  backgroundColor: simulation.isDraft
                    ? '#f6f9fc'
                    : simulation.status === 'CANCEL'
                    ? '#fef7f7'
                    : ''
                }"
                >Volume Estimé</span
              ><!-- CARRIED_OUT -->
            </li>

            <li
              class="giga-simulation_status"
              :class="{ done: simulation.status == 'TO_BE_TRANSFORMED' }"
            >
              <span
                :style="{
                  backgroundColor: simulation.isDraft
                    ? '#f6f9fc'
                    : simulation.status === 'CANCEL'
                    ? '#fef7f7'
                    : ''
                }"
                >En traitement</span
              ><!-- TO_BE_TRANSFORMED -->
            </li>
          </ul>
        </div>
        <!-- DETAILS -->
        <div class="giga-flexible_card_body">
          <div class="giga-flexible_card_details">
            <ul
              v-if="
                simulation.status !== 'CARRIED_OUT' &&
                  simulation.status !== 'TO_BE_TRANSFORMED'
              "
              class="giga-simulation_card_details"
            >
              <li class="giga-simulation_card_detail">
                <label>{{ $t("estimated_end_date") }}</label>
                <p>
                  {{
                    simulation.deliveryDate > 0
                      ? moment(simulation.deliveryDate, "x")
                          .locale("fr")
                          .format("DD MMMM YYYY")
                      : moment()
                          .locale("fr")
                          .format("DD MMMM YYYY")
                  }}
                </p>
              </li>
            </ul>

            <ul
              v-if="
                simulation.status === 'CARRIED_OUT' ||
                  simulation.status === 'TO_BE_TRANSFORMED'
              "
            >
              <li class="giga-simulation_card_detail">
                <label>{{ $t("Volume théorique classique") }}</label>
                <p>
                  {{ simulation.expectedThClassicVolume | formatNumber }} kWh
                  cumac
                </p>
              </li>
              <li class="giga-simulation_card_detail">
                <label>{{ $t("Volume théorique précaire") }}</label>
                <p>
                  {{ simulation.expectedThPrecarityVolume | formatNumber }} kWh
                  cumac
                </p>
              </li>
              <li class="giga-simulation_card_detail">
                <label>{{ $t("economic_valorisation") }}</label>
                <p v-if="simulation.economicValorisation">
                  {{ simulation.economicValorisation | formatNumber }} €
                </p>
                <p v-else>En cours</p>
              </li>
            </ul>
          </div>
          <div class="giga-flexible_card_actions">
            <div class="giga-flexible_card_icons">
              <button
                class="simulation-card_details_button"
                @click="onClickDetailSimulation(simulation.id)"
              >
                <img
                  src="@/assets/images/icons/mi-list.svg"
                  alt="detail"
                  class="detail-icon"
                />
              </button>
              <button
                v-if="
                  !isVIEWER &&
                    simulation.status !== 'CANCEL' &&
                    simulation.status !== 'TO_BE_TRANSFORMED'
                "
                class="simulation-card_edit_button"
                @click="onRowSelected(simulation.id)"
              >
                <img
                  src="@/assets/images/icons/pepicons-pop-pen.svg"
                  alt="Edit"
                  class="edit-icon"
                />
              </button>
              <button
                v-if="
                  simulation.status !== 'CANCEL' &&
                    simulation.status !== 'TO_BE_TRANSFORMED'
                "
                class="work-card_dlete_button"
                @click="openConfirmModal('delete-simulation-reason', simulation.id)"
              >
                <img
                  src="@/assets/images/icons/gravity-ui-trash-bin.svg"
                  alt="delete"
                  class="delete-icon"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { helpers } from "@/shared/helper";

export default {
  name: "SimulationCard",
  props: ["simulation", "canValidateSimulation"],
  methods: {
    ...mapActions("simulation", ["selectedSimulationIdAction"]),
    onRowSelected(id) {
      this.$router.push({ name: "EditSimulation", params: { id: id } });
      // EditSimulator
    },
    onClickDetailSimulation(id) {
      this.$router.push({ name: "SimulationDetail", params: { id: id } });
      // DetailSimulator
    },
    openConfirmModal(modal, simulationId) {
      this.selectedSimulationIdAction({ simulationId });
      this.$root.$emit("bv::show::modal", modal);
    }
  },
  computed: {
    isVIEWER() {
      return helpers.isVIEWER();
    }
  }
};
</script>
<style lang="scss" scoped>
.is-draft {
  border-color: #e0e7ee;
}

.no-footer-border {
  border: unset;
}
.header-custom-padding {
  padding: 20px;
}
.body-custom-padding {
  padding: 15px 25px 5px 25px;
}
.HeaderClass {
  display: flex;
  align-items: center;
  padding-right: 0px;
}
.draft-badge {
  height: 23px;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 4px 8px;
  border-radius: 30px;
  border-style: solid;
  border-width: 1px;

  background-image: linear-gradient(to bottom, #e0e7ee, #e0e7ee),
    linear-gradient(to bottom, #cdd8e3, #eef3f9);
  background-origin: border-box;
  margin-bottom: 6px;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #6b829a;
  border-color: #cdd8e3;
}

.perdu-badge {
  height: 23px;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 4px 8px;
  border-radius: 30px;
  border-style: solid;
  border-width: 1px;
  background-image: linear-gradient(to bottom, #ffe9e4, #ffe9e4),
    linear-gradient(to bottom, #ffc6be, #ffdbd9);
  background-origin: border-box;
  margin-bottom: 6px;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #cd1a02;
  border-color: #ffc6be;
}
.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip-container .tooltip-text {
  visibility: hidden;
  width: auto;
  white-space: nowrap;
  background:#fffc9d;
  color: black;
  text-align: center;
  padding: 6px;
  border-radius: 6px;
  position: absolute;
  z-index: 10;
  top: 125%;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  font-size: 12px;
}
.tooltip-container:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
.warning-icon,
.rge-icon {
  width: 22px;
  height: 22px;
  margin-left: 6px;
  vertical-align: middle;
  cursor: pointer;
}
.triangle {
  fill: #fffc9d;
  stroke: black;
  stroke-width: 1px;
  stroke-linejoin: round;
}
.exclamation-mark {
  fill: black;
}
</style>
